import { cva } from 'class-variance-authority';

import type { VariantProps } from 'class-variance-authority';
import type { FC, HTMLAttributes } from 'react';

import s from './CardDescription.module.css';

const variants = cva(s.description, {
  defaultVariants: {
    variant: 'neutral',
  },
  variants: {
    variant: {
      invert: s.variant_invert,
      neutral: s.variant_neutral,
      primary: s.variant_primary,
    },
  },
});

type CardDescriptionProps = HTMLAttributes<HTMLParagraphElement> &
  VariantProps<typeof variants> & {
    description: string;
  };

const CardDescription: FC<CardDescriptionProps> = ({ className, description, variant, ...props }) => (
  <p className={variants({ className, variant })} {...props}>
    {description}
  </p>
);

export { CardDescription };
